/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import DokanIcons from '../../icon/DokanIcons';

/* Props: 
productName= Product Name , 
isFeatured = Check is the product is a featured Product 
*/
const DokanTableItemShortTitle = ({ productName, isFeatured }) => (
    <div className="m-0 flex items-baseline">
        {/* <h5 className="text-base text-primary font-bold ">{productName}</h5> */}
        <a href="#">{productName}</a>

        {/* if product is a featured product -> show Start */}
        <span className="pl-10px">{isFeatured ? <DokanIcons icon="#star" size={3} /> : ''}</span>
    </div>
);

export default DokanTableItemShortTitle;
